import { Endpoint } from '@business/api/endpoint';
import { FeedbackId, CompactAssistantFeedbackResponse, FeedbacksRequest } from '@business/entities/assistant_feedback';
import { Paginate } from '@business/entities/common';
import { R } from '@core/utils/r';

export function fetchFeedbacks(request: FeedbacksRequest) {
  const params = R.objectCompact(request);
  return Endpoint.get<Paginate<CompactAssistantFeedbackResponse>>(`@gc/feedbacks`, { params });
}

export function fetchFeedback(id: FeedbackId) {
  return Endpoint.get<CompactAssistantFeedbackResponse>(`@gc/feedbacks/feedback/${id}`);
}

export function createComment(feedbackId: FeedbackId, comment: string) {
  const data = { comment };
  return Endpoint.post<CompactAssistantFeedbackResponse>(`@gc/feedbacks/feedback-comment/${feedbackId}`, { data });
}
